/* CPPerformance — homepage merchandising + lower trust block */
(function () {
  function norm(value) {
    return String(value || '').toLowerCase().trim().replace(/\s+/g, ' ');
  }

  function el(html) {
    const t = document.createElement('template');
    t.innerHTML = html.trim();
    return t.content.firstElementChild;
  }

  function mainHome() {
    return document.querySelector("main[data-template='index']");
  }

  function sectionByHeading(main, needle) {
    if (!main) return null;
    const heading = Array.from(main.querySelectorAll('h1,h2,h3')).find(function (node) {
      return norm(node.textContent).indexOf(norm(needle)) > -1;
    });
    return heading ? (heading.closest('.shopify-section') || heading.parentElement) : null;
  }

  function cleanupOldExtraCategories() {
    document.querySelectorAll('[data-cp-extra-categories]').forEach(function (node) {
      node.remove();
    });
  }

  function moveSierstukkenToGolfSlot() {
    const main = mainHome();
    if (!main) return;
    const tips = sectionByHeading(main, 'Tips & nieuws');
    const spotlight = main.querySelector('[data-cp-sierstukken-spotlight]');
    if (!tips || !spotlight) return;
    if (tips.previousElementSibling !== spotlight) {
      tips.insertAdjacentElement('beforebegin', spotlight);
    }
    spotlight.classList.add('cp-sierstukken-spotlight--featured-slot');
  }

  function moveGolfAfterNews() {
    const main = mainHome();
    if (!main) return;
    const tips = sectionByHeading(main, 'Tips & nieuws');
    const golf = sectionByHeading(main, 'Golf 8 GTI bodykit');
    if (!tips || !golf || tips === golf) return;

    if (tips.nextElementSibling !== golf) {
      tips.insertAdjacentElement('afterend', golf);
    }
    golf.classList.add('cp-golf-after-news');

    const heading = Array.from(golf.querySelectorAll('h2,h3')).find(function (node) {
      return norm(node.textContent).indexOf('golf 8 gti bodykit') > -1;
    });
    if (heading && !golf.querySelector('.cp-golf-eyebrow')) {
      heading.insertAdjacentElement('beforebegin', el('<span class="cp-golf-eyebrow">Golf 8 • Styling</span>'));
    }
  }

  function addNewsContext() {
    const main = mainHome();
    if (!main) return;
    const tips = sectionByHeading(main, 'Tips & nieuws');
    if (!tips || tips.querySelector('.cp-news-context')) return;
    const heading = Array.from(tips.querySelectorAll('h2,h3')).find(function (node) {
      return norm(node.textContent).indexOf('tips & nieuws') > -1;
    });
    if (!heading) return;
    heading.insertAdjacentElement('afterend', el('<p class="cp-news-context">Praktische uitleg, productnieuws en inspiratie voor jouw volgende upgrade.</p>'));
  }

  function mountOrderConfidence() {
    const main = mainHome();
    if (!main) return;
    const golf = sectionByHeading(main, 'Golf 8 GTI bodykit');
    if (!golf) return;

    let block = main.querySelector('[data-cp-order-confidence]');
    if (!block) {
      block = el(`
        <section class="cp-order-confidence" data-cp-order-confidence aria-labelledby="cp-order-confidence-title">
          <div class="cp-order-confidence__inner">
            <div class="cp-order-confidence__intro">
              <span class="cp-order-confidence__eyebrow">Zonder twijfel bestellen</span>
              <h2 id="cp-order-confidence-title">Snel naar de juiste upgrade.</h2>
              <p>Kies je onderdeel, laat bij twijfel de pasvorm controleren en reken via de beveiligde Shopify-checkout af. Montage is mogelijk op afspraak in Nederweert.</p>
              <div class="cp-order-confidence__actions">
                <a class="cp-order-confidence__primary" href="/collections/bestsellers">Bekijk bestsellers</a>
                <a class="cp-order-confidence__secondary" href="/pages/contact">Vraag pasvorm na</a>
              </div>
            </div>
            <div class="cp-order-confidence__grid">
              <div class="cp-order-confidence__card"><span>01</span><strong>Pasvormcheck</strong><p>Vul je voertuiggegevens in of laat ons eerst controleren.</p></div>
              <div class="cp-order-confidence__card"><span>02</span><strong>Direct afrekenen</strong><p>Gebruik de versnelde checkout op de productpagina.</p></div>
              <div class="cp-order-confidence__card"><span>03</span><strong>Montage mogelijk</strong><p>Op afspraak bij CPPerformance in Nederweert.</p></div>
              <div class="cp-order-confidence__card"><span>04</span><strong>Persoonlijk advies</strong><p>Voor vragen over uitvoering, pasvorm of montage.</p></div>
            </div>
          </div>
        </section>
      `);
    }

    if (golf.nextElementSibling !== block) {
      golf.insertAdjacentElement('afterend', block);
    }
  }

  function mountAll() {
    cleanupOldExtraCategories();
    moveSierstukkenToGolfSlot();
    moveGolfAfterNews();
    addNewsContext();
    mountOrderConfidence();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountAll);
  else mountAll();

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(mountAll, 0);
  });

  const observer = new MutationObserver(function () {
    window.clearTimeout(observer._cpMerchTimer);
    observer._cpMerchTimer = window.setTimeout(mountAll, 120);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
